import ApplicationController from '../support/application_controller'
import I18n                  from '../support/i18n'
import $fq                   from '../support/fake_query'

export default class extends ApplicationController {

  static targets = ['submitButton', 'textarea', 'charCount']

  static values = {}

  static classes = []

  initialize() { }

  connect() { }

  // ==== Controllers

  // ==== Actions

  formInput(event) {
    if (event.target.closest('.l-csat-review')) return

    this.submitButtonTarget.textContent = I18n.t('app.continue')
    $fq(this.submitButtonTarget).removeClass('-style-dc-green-secondary').addClass('-style-dc-green')
  }

  updateCharCount() {
    const max = this.textareaTarget.maxLength
    const current = this.textareaTarget.value.length

    this.charCountTarget.textContent = `${current}/${max}`
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
